import { filterByIncludes } from '../../../utils';
export var filterEntityTypes = function (term, options) {
    return {
        renderedItems: filterByIncludes(term, options)
    };
};
